export const menuOptionsSort = {
  trending: "Trending",
  new: "Newest",
  old: "Oldest"
};
